import { Badge } from '@bennows/boows-react';
import { CircleAlert, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { TenantProblem } from './useProblems';

/** One badge per problem of a tenant, errors red, warnings amber, each with its count (REQ-140-015). */
export function ProblemBadges({ problems }: { readonly problems: readonly TenantProblem[] }) {
  const { t } = useTranslation();
  return (
    <ul className="ui-console-badges">
      {problems.map((problem) => (
        <li key={problem.kind}>
          <Badge tone={problem.severity === 'error' ? 'danger' : 'warning'} icon={problem.severity === 'error' ? <CircleAlert aria-hidden="true" /> : <TriangleAlert aria-hidden="true" />}>
            {t(`problems.kinds.${problem.kind}`, { count: problem.count })}
          </Badge>
        </li>
      ))}
    </ul>
  );
}
